
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/empresa",
      function () {
        return require("private-next-pages/empresa/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/empresa"])
      });
    }
  